module.exports = "/assets/data/dc00e3b7b4d52bb92cb39cff130aebbf-MK9.data.json";